<script setup lang="ts">
// Every post is published by mychar.gg: logo + name, no per-post author.
defineProps<{
  date?: string | null
  readingTime?: number
}>()

function formatDate(date?: string | null): string {
  if (!date) return ''
  return new Date(date).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })
}
</script>

<template>
  <div class="flex items-center gap-3">
    <span class="flex size-10 shrink-0 items-center justify-center rounded-full border border-default bg-elevated p-2">
      <AppLogoMark class="size-full" />
    </span>
    <div class="text-sm">
      <p class="font-medium text-highlighted">
        mychar.gg
      </p>
      <p class="text-muted">
        <template v-if="date">
          {{ formatDate(date) }}
        </template>
        <template v-if="date && readingTime">
          ·
        </template>
        <template v-if="readingTime">
          {{ readingTime }} min read
        </template>
      </p>
    </div>
  </div>
</template>
